import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { DomainService } from 'app/core/services/domain.service';
import { NotificationService } from 'app/core/services/notification.service';
import { AuthService } from 'app/core/services/auth.service';
import { EnvironmentService } from 'app/core/services/environment.service';
import { animate, state, style, transition, trigger } from '@angular/animations';


@Component({
  selector: 'itpx-class-tile-details',
  templateUrl: './class-tile-details.component.html',
  styleUrls: ['./class-tile-details.component.css'],
  animations: [
    trigger('rotate',
      [
        state('less', style({ transform: 'rotate(180deg)' })),
        state('more, void', style({ transform: 'rotate(0deg)' })),
        transition(
          'more <=> less', animate('0.4s ease-in-out'))
      ])]
})
export class ClassTileDetailsComponent implements OnInit {
  @Input() target: Array<any> = [];
  @Input() name: string;
  @Input() isClass: boolean;
  @Input() imageUrl: string;
  @Input() tile: any;
  @Input() percentage: any;
  @Input() type: any;
  @Input() assignment: any;
  @Input() venue: any;
  @Input() details: any;

  private domain: any;
  private images: string;
  private isElearning: boolean = false;
  private course: any;
  private more: string = 'less';
  displayAssignments: string[];

  constructor(
    private router: Router,
    private domainService: DomainService,
    private authService: AuthService,
    private notificationService: NotificationService,
    private environmentService: EnvironmentService
  ) {
  }

  ngOnInit() {
    this.domain = this.domainService.getDomain();
    this.images = this.environmentService.config['server'].images;

    this.isElearning = this.type === 'eLearning';

    if (this.assignment.productVariant)
      this.course = {
        title: this.assignment.productVariant.name,
        product: {
          certificateType: this.removeDashes(this.assignment.productVariant.certificateType),
          deliveryFormat: this.removeDashes(this.assignment.productVariant.deliveryFormat),
          language: this.assignment.productVariant.languageValue
        },
        startedOn: this.assignment.startedOn,
        finishedOn: this.assignment.finishedOn
      }
  }

  onClick(event: any) {
    event.stopPropagation();
    this.more = this.more === 'more' ? 'less' : 'more';
  }

  private removeDashes(val: string): string {
    return val ? val.replace('-', ' ') : null;
  }

}



// WEBPACK FOOTER //
// ./src/app/core/components/class/class-tile-details/class-tile-details.component.ts